import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { CsvUploadButton } from './CsvUploadButton';

type Props = {
  children?: never;
  errorMessage: string;
  isUploading: boolean;
  onUploadCsvClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const CsvFormatError: React.FC<Props> = ({
  errorMessage,
  isUploading,
  onUploadCsvClick,
}) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Section>
        <H2>{t('text.user.index.formatError')}</H2>
        <Span>{errorMessage}</Span>
        <CsvUploadButton
          isUploading={isUploading}
          onChange={onUploadCsvClick}
        />
      </Section>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 340px;
  width: 100%;
  margin-bottom: 16px;
  background-color: #ffffff;
`;

const H2 = styled.h2`
  font-size: 14px;
  font-weight: 600;
`;

const Span = styled.span`
  font-size: 14px;
  color: #9f3a38;
`;
